export const MFA_PENDING_KEY = 'demandjet.mfaPending';

export function storeMfaPending(pending) {
  sessionStorage.setItem(MFA_PENDING_KEY, JSON.stringify(pending));
}

export function readMfaPending() {
  try {
    const raw = sessionStorage.getItem(MFA_PENDING_KEY);
    if (!raw) return null;
    const pending = JSON.parse(raw);
    if (!pending?.challenge) return null;
    return pending;
  } catch {
    return null;
  }
}

export function clearMfaPending() {
  sessionStorage.removeItem(MFA_PENDING_KEY);
}
